import { render } from "./SectionPettyCashForm.vue?vue&type=template&id=0f5e0ab2"
import script from "./SectionPettyCashForm.vue?vue&type=script&lang=js"
export * from "./SectionPettyCashForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__